import { type ValidateEmailAdapter } from '../../validation/protocols/validate-email-adapter'
import { validate } from 'email-validator'

export class EmailValidatorAdapter implements ValidateEmailAdapter {
  validate (email: string): boolean {
    return validate(email)
  }
}
